import { Illustrations } from "@/illustrations";
import { Button, Container, Text } from "@chakra-ui/react";
import { Icon } from "@pufflig/prompt-studio-ui";
import { Suspense } from "react";

interface EmptyTeamListProps {
  onCreateTeam: () => void;
}

export const EmptyTeamList = (props: EmptyTeamListProps) => {
  const { onCreateTeam } = props;

  return (
    <Container
      centerContent
      maxW="100%"
      display="flex"
      flexDir="column"
      borderRadius="8px"
      backgroundColor="background.secondary"
      gap="24px"
      mb="15rem"
      padding="2rem"
    >
      <Suspense fallback={null}>
        <Illustrations.StartupTeamwork />
      </Suspense>
      <Container centerContent gap="4px">
        <Text textStyle="label/L/medium">No teams yet</Text>
        <Text textStyle="label/S/regular">Create first team and invite members</Text>
      </Container>
      <Button variant="primary" leftIcon={<Icon name="add" />} onClick={onCreateTeam}>
        Create new team
      </Button>
    </Container>
  );
};
